import {BaseSlider} from "./BaseSlider";

export class LatestSlider extends BaseSlider {
    constructor() {
        super('.swiper-latest');

        this.initSlider()
    }
}